const { tablet } = require('./breakpoints');

function isMobileLayout() {
    return window.innerWidth < tablet;
}

module.exports = isMobileLayout;
